import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalFooter
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  ASSESSMENTFORMTXT,
  ASSESSMENTSCORINGMETHODS,
  FORMTYPES,
  FormFrequency,
  LS_AUTHORITY_KEY,
  USER_ROLE,
  startYear,
} from "../../../core/constants/common";
import FormService from "../../../core/service/FormService";
import RiskConfigService from "../../../core/service/RiskConfigService";
import LogoUploadCard from "../../../components/Logo/LogoUploadCard";
import Multiselect from "multiselect-react-dropdown";

function NewFormModal({ t, showModal, regulation, assessmentType, handleNewForm, formToUpdate, onFormSave }) {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(showModal);
  const [languages, setLanguages] = useState([]);
  const [regulations, setRegulations] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [formData, setFormData] = useState({
    selLang: formToUpdate?.id > 0 ? formToUpdate.selectedLanguage?.id ?? '1' : '1',
    formName: formToUpdate?.id > 0 ? formToUpdate.name : '',
    formDesc: formToUpdate?.id > 0 ? formToUpdate.description : '',
    formTypeVal: formToUpdate?.id > 0
      ? (formToUpdate.selfAssessment
        ? (formToUpdate.formType === 'SURVEY' ? 'MATERIALITY' : 'SELFASSESSMENT')
        : 'SUPPLIERASSESSMENT')
      : assessmentType ?? '',
    scoringmethod: formToUpdate?.id > 0 ? formToUpdate.scoringMethod ?? 'NONE' : 'NONE',
    selRegulation: formToUpdate?.id > 0 ? formToUpdate.regulation?.id : regulation ?? '',
    locationSpecific: formToUpdate?.id > 0 ? formToUpdate.locationSpecific : true,
    reviewRequired: formToUpdate?.id > 0 ? formToUpdate.reviewRequired : false,
    historicalDataSupported: formToUpdate?.id > 0 ? formToUpdate.historicalDataSupported : false,
    historicalDataYears: formToUpdate?.id > 0 ? formToUpdate.historicalDataYears ?? [] : [],
    frequencies: formToUpdate?.id > 0 ? formToUpdate.frequencies ?? [] : [],
  });
  const [yearOptions, setYearOptions] = useState([]);
  let lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    let options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push({
        value: i,
        displayValue: i
      });
    }
    setYearOptions(options);
    getRegulations();
    getLanguages();
  }, []);

  const close = () => {
    handleNewForm("", false);
  };

  const getLanguages = () => {
    FormService.getLanguages()
      .then((response) => {
        setLanguages([...response.data]);
      })
      .catch((error) => { });
  };

  const getRegulations = () => {
    RiskConfigService.getRegulationsNoFIlter(lsData.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then((response) => {
        setRegulations([...response.data]);
      })
      .catch((error) => { });
  };

  const handleCreateForm = (e) => {
    if (!formData.formName || !formData.formDesc || !formData.formTypeVal || !formData.selLang || !formData.selRegulation) {
      setValidated(true);
      return;
    }
    if (formData.historicalDataSupported && formData.historicalDataYears?.length > 5) {
      toast.error(t('HistDaatYearsLimitError.label'), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
      return;
    }
    if (formData.frequencies?.length === 0) {
      toast.error('Select frequency', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
      return;
    }
    let formType =
      formData.formTypeVal === "SUPPLIERASSESSMENT"
        ? false
        : formData.formTypeVal === "SELFASSESSMENT" && true;
    const params = {
      name: formData.formName,
      description: formData.formDesc,
      regulation: {
        id: formData.selRegulation,
      },
      selectedLanguage: {
        id: formData.selLang,
      },
      scoringMethod: formData.scoringmethod,
      selfAssessment: formType,
      locationSpecific: formData.locationSpecific,
      reviewRequired: formData.reviewRequired,
      historicalDataSupported: formData.historicalDataSupported,
      historicalDataYears: formData.historicalDataYears,
      frequencies: formData.frequencies
    };
    let req;
    if (logoFile == null) {
      req = FormService.createNewForm(params);
    } else {
      const formData = new FormData();
      formData.append("logo", new Blob([logoFile], { type: logoFile.type }));
      formData.append("formDTO", new Blob([JSON.stringify(params)], { type: "application/json" }))
      req = FormService.createNewFormWithLogo(formData);
    }
    req.then((response) => {
      if (response.status !== 200 && response.status !== 201) return;

      toast.success("Success", {
        position: toast.POSITION.TOP_RIGHT,
      });
      handleNewForm(response.data, true);
    })
      .catch((error) => { });
    setValidated(true);
  };

  const onLogoChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    setLogoFile(file);
  };

  const getSelectedYears = () => {
    const data = [];
    formData?.historicalDataYears?.forEach(y => {
      data.push({
        value: y,
        displayValue: y
      });
    });
    return data;
  };

  const onSelectDeSelectYear = (d) => {
    const f = { ...formData };
    const index = f.historicalDataYears?.indexOf(d.value);
    if (index >= 0) {
      f.historicalDataYears.splice(index, 1);
    } else {
      f.historicalDataYears.push(d.value);
    }
    setFormData(f);
  };

  const updateForm = () => {
    if (!formToUpdate.id || !formData.formName || !formData.formDesc) {
      setValidated(true);
      return;
    }
    if (formData.historicalDataSupported && formData.historicalDataYears?.length > 5) {
      toast.error(t('HistDaatYearsLimitError.label'), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
      return;
    }
    if (formData.frequencies?.length === 0) {
      toast.error('Select frequency', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
      return;
    }
    const params = {
      name: formData.formName,
      description: formData.formDesc,
      scoringMethod: formData.scoringmethod,
      reviewRequired: formData.reviewRequired,
      historicalDataSupported: formData.historicalDataSupported,
      historicalDataYears: formData.historicalDataYears,
      frequencies: formData.frequencies
    };
    let req;
    if (logoFile) {
      const formData = new FormData();
      params.id = formToUpdate.id;
      formData.append("logo", new Blob([logoFile], { type: logoFile.type }));
      formData.append("formDTO", new Blob([JSON.stringify(params)], { type: "application/json" }))
      req = FormService.createNewFormWithLogo(formData, formToUpdate.id);
    } else {
      req = FormService.updateForm(formToUpdate.id, params);
    }
    req.then((response) => {
      if (response.status !== 200 && response.status !== 201) return;

      toast.success("Success", {
        position: toast.POSITION.TOP_RIGHT,
      });
      onFormSave();
    })
      .catch((error) => { });
    setValidated(true);
  };

  const isFormBeingUpdated = () => {
    return formToUpdate.id > 0;
  };

  const getSelectedFrequencies = () => {
    const data = [];
    formData?.frequencies?.forEach(f => {
      data.push({
        value: f,
        displayValue: f
      });
    });
    return data;
  };

  const onSelectDeSelectFrequency = (d) => {
    const f = { ...formData };
    const index = f.frequencies?.indexOf(d.value);
    if (index >= 0) {
      f.frequencies.splice(index, 1);
    } else {
      f.frequencies.push(d.value);
    }
    setFormData(f);
  };

  return (
    <Modal
      show={show}
      onHide={close}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title as="h5">
          {t("CreateNewForm.label")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated}>

          {/* <div className="py-2">
            <label className="mb-1">
              {t("Logo.label")}
            </label>
            <LogoUploadCard onFileChange={(e) => onLogoChange(e)} />
          </div> */}
          <div className="row m-0">
            <div className="col-6 p-2">
              <label htmlFor="title" className="mb-1">
                {t("Title.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              
              <input
                type="text"
                className="form-control"
                id="exampleFormControlInput1"
                onChange={(e) => setFormData({ ...formData, formName: e.target.value })}
                value={formData.formName}
                required
                disabled={formToUpdate?.id > 0 ? (formData.formTypeVal == 'SELFASSESSMENT' ? false : true) : false}
              />
            </div>
           
            <div className="col-6 p-2">
              <label htmlFor="type" className="mb-1">
                {t("Type.label")}
                <span className="text-danger ms-1">*</span>
              </label>
            
              <select
                className="form-select"
                onChange={(e) => setFormData({ ...formData, formTypeVal: e.target.value })}
                required
                value={formData.formTypeVal}
                disabled={isFormBeingUpdated()}>
                <option value="" disabled hidden>
                  {t("Select.label")}
                </option>
                {FORMTYPES.map((type) => (
                  <option value={type.value} key={type.value}>
                    {t(`${type.value}.label`)}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 p-2">
              <label className="mb-1">
                {t("SelectRegulation.label")}
                <span className="text-danger ms-1">*</span>
                </label> 
              <select
                className="form-select"
                required
                onChange={(e) => setFormData({ ...formData, selRegulation: e.target.value })}
                value={formData.selRegulation}
                disabled={isFormBeingUpdated()}>
                <option value="" disabled hidden>
                  {t("Select.label")}
                </option>
                {
                  formData.formTypeVal === 'SUPPLIERASSESSMENT'
                    ?
                    regulations?.filter(r => r.type === 'R')?.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))
                    :
                    regulations?.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))
                }
              </select>
            </div>
            <div className="col-6 p-2">
              <label htmlFor="language" className="mb-1">
                {t("Language.label")}
                <span className="text-danger ms-1">*</span>
              </label>
              
              <select
                className="form-select"
                required
                onChange={(e) => setFormData({ ...formData, selLang: e.target.value })}
                value={formData.selLang}
                disabled={isFormBeingUpdated()}>
                <option value="" disabled hidden>
                  {t("Select.label")}
                </option>
                {languages != null &&
                  languages !== undefined &&
                  languages.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-12 p-2">
              <label htmlFor="desc" className="mb-1">
                {t("Description.label")}
                <span className="text-danger ms-1">*</span>
              </label>
             
              <textarea
                className="form-control"
                required
                onChange={(e) => setFormData({ ...formData, formDesc: e.target.value })}
                defaultValue={formData.formDesc}
                disabled={formToUpdate?.id > 0 ? (formData.formTypeVal == 'SELFASSESSMENT' ? false : true) : false}
              ></textarea>
            </div>
            {formData.formTypeVal === ASSESSMENTFORMTXT && (
              <div className="py-2">

                <label htmlFor="" className="mb-1">
                  {t("ScoreingMethod.label")}
                </label>
                <select
                  className="form-select w-100"
                  required
                  id="scoringmethods"
                  onChange={(e) => setFormData({ ...formData, scoringmethod: e.target.value })}
                  value={formData.scoringmethod}
                >
                  {ASSESSMENTSCORINGMETHODS.map((opt) => (
                    <option key={opt.key} value={opt.key}>
                      {opt.name}
                    </option>
                  ))}
                </select>
                {formData.scoringmethod !== "NONE" && (
                  <small className="desc-txt">
                    {t("Scoreofthheswctioncalculated.label")}
                    <span className="text-lower">{formData.scoringmethod}</span>{" "}
                    {formData.scoringmethod === "AVERAGE" && <span>{t("score.label")}</span>} {t("ofallthequestionsinsection.label")}
                  </small>
                )}
              </div>
            )}
            {
              formData.formTypeVal === 'SELFASSESSMENT'
              && formData.selRegulation > 0
              && regulations.find(r => r.id === +formData.selRegulation)?.type === 'S' &&
              <div className="col-4 p-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="locationSpecificCheck"
                  checked={formData.locationSpecific}
                  onChange={() => setFormData({ ...formData, locationSpecific: !formData.locationSpecific })}
                  disabled={isFormBeingUpdated()} />
                <label className="form-check-label px-1" htmlFor="locationSpecificCheck">
                  {t("LocationSpecific.label")}
                </label>
              </div>
            }
            <div className="col-4 p-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="reviewRequiredCheck"
                checked={formData.reviewRequired}
                onChange={() => setFormData({ ...formData, reviewRequired: !formData.reviewRequired })}
              />
              <label className="form-check-label px-1" htmlFor="reviewRequiredCheck">
                {t("DataApprovalNeeded.label")}
              </label>
            </div>
            <div className="col-4 p-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="hisDataRequiredCheck"
                checked={formData.historicalDataSupported}
                onChange={() => setFormData({ ...formData, historicalDataSupported: !formData.historicalDataSupported })}
              />
              <label className="form-check-label px-1" htmlFor="hisDataRequiredCheck">
                {t("SupportHistoricalData.label")}
              </label>
            </div>
           
            {
              formData.historicalDataSupported &&
              <div className="col-6 p-2">
                <label className="mb-1" htmlFor="yearSelector">{t("Years.label")}</label>
                <Multiselect
                  id="yearSelector"
                  key="yearSelector"
                  options={yearOptions}
                  displayValue="displayValue"
                  selectedValues={getSelectedYears()}
                  onSelect={(selectedList, selectedItem) => {
                    onSelectDeSelectYear(selectedItem);
                  }}
                  onRemove={(selectedList, selectedItem) => {
                    onSelectDeSelectYear(selectedItem);
                  }}
                />
              </div>
            }
           <div className="col-6 p-2">
              <label className="mb-1" htmlFor="yearSelector">{t("Frequency.label")}   <span className="text-danger ms-1">*</span></label>
              <Multiselect
                manda
                id="freqSelector"
                key="freqSelector"
                placeholder={t("Select.label")}
                options={Object.values(FormFrequency).map(({ text, value }) => ({
                  value: text,
                  displayValue: t(`${text}.label`)
                }))}
                displayValue="displayValue"
                selectedValues={getSelectedFrequencies()}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectFrequency(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectFrequency(selectedItem);
                }}
              />
            </div>
          </div>
        </Form>
      </Modal.Body>
      <ModalFooter>
        <Button variant="secondary" className="me-2" onClick={close}>
          {t("Close.label")}
        </Button>
        {
          formToUpdate.id > 0
            ?
            <Button variant="primary" onClick={() => updateForm()} className="sbmBtn">
              {t("Update.label")}
            </Button>
            :
            <Button variant="primary" onClick={() => handleCreateForm("NEW")} className="sbmBtn">
              {t("Proceed.label")}
            </Button>
        }
      </ModalFooter>
    </Modal>
  );
}

export default withTranslation()(NewFormModal);
